<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-cascader
          style="float: left;"
          placeholder="请选择商品分类"
          v-model="categoryId"
          :options="categoryOptions"
        >
        </el-cascader>
        <el-select
          placeholder="请选择供应商"
          v-model="supplierId"
          style="float: left;"
        >
          <el-option
            v-for="item in supplierOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-select
          placeholder="请选择是否在首页展示"
          v-model="homePage"
          style="float: left;"
        >
          <el-option
            v-for="item in showOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-input
          v-model="keywords"
          placeholder="请输入关键字"
          style="float: left;"
        ></el-input>
        <el-button @click="_getList" type="primary" style="float: left;"
          >搜索</el-button
        >
        <!-- <el-button @click="export2Excel" ref="exportData">导出为xls</el-button> -->
        <el-button @click="handleAdd">新增商品</el-button>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow"
        >
        </el-pagination>
      </div>
      <div class="userTable">
        <el-table
          ref="multipleTable"
          :data="productDatas"
          tooltip-effect="dark"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column
          type="selection"
          width="60">
        </el-table-column> -->
          <el-table-column prop="id" label="商品编号" width="100">
          </el-table-column>
          <el-table-column prop="name" label="商品名" width="200">
          </el-table-column>
          <el-table-column prop="subTitle" label="副标题" width="150">
          </el-table-column>
          <el-table-column prop="type" label="商品类型" width="100">
            <template slot-scope="scope">{{ getProductType(scope) }}</template>
          </el-table-column>
          <el-table-column prop="categoryName" label="分类" width="100">
          </el-table-column>
          <!-- <el-table-column
          prop="stock"
          label="库存"
          width="100">
        </el-table-column> -->
          <el-table-column prop="salesVolume" label="销量" width="100">
          </el-table-column>
          <el-table-column prop="commentVolume" label="评论量" width="100">
          </el-table-column>
          <el-table-column prop="giveScoreRate" label="赠送积分比例" width="100">
          </el-table-column>
          <el-table-column
            prop="saleable"
            :formatter="handleGroupValue"
            label="是否团购商品"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="isGiftPkg"
            :formatter="handleGiftPkgValue"
            label="是否为消费礼包"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="saleable"
            :formatter="handleStatusValue"
            label="状态"
            width="100"
          >
          </el-table-column>
          <el-table-column label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleStatus(scope.row, 1)"
                v-if="scope.row.saleable == 0"
                >上架</el-button
              >
              <el-button
                size="mini"
                @click="handleStatus(scope.row, 0)"
                v-if="scope.row.saleable == 1"
                >下架</el-button
              >
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog
        title="添加商品"
        :visible.sync="addDialogVisible"
        width="40%"
        center
        :append-to-body="true"
      >
        <el-form
          :label-position="left"
          label-width="100px"
          :model="addData"
          ref="addForm"
        >
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="addData.name"></el-input>
          </el-form-item>
          <el-form-item label="商品价格" prop="price">
            <el-input v-model="addData.price"></el-input>
          </el-form-item>
          <el-form-item label="商品积分" prop="score">
            <el-input v-model="addData.score"></el-input>
          </el-form-item>
          <el-form-item label="商品主图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile"
              :limit="1"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="商品详情图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile1"
              :limit="5"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_addProduct('addForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="20%"
        :append-to-body="true"
        center
      >
        <span>确定要删除当前商品吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_deleteProduct()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  getCategorys,
  getAllSupplier,
  getLogistics,
  getAllProduct,
  addProduct,
  modifyStatus,
  deleteProduct,
  uploadFile1
} from "api/request";
import { ERR_OK } from "api/config";
import { formatDate, loadingInstance, Success, Error } from "common/js/util";
export default {
  components: { MSidebar, MHeader },
  data() {
    return {
      token: window.localStorage.getItem("token"),
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      paginationShow: false,
      ca: null,
      supplierOptions: [],
      showOptions: [
        {
          id: 1,
          name: "是"
        },
        {
          id: 0,
          name: "否"
        }
      ],
      categoryOptions: [],
      logisticsOptions: [],
      homePage: null,
      supplierId: null,
      categoryId: null,
      keywords: null,
      addDialogVisible: false,
      deleteDialogVisible: false,
      detailDialogVisible: false,
      left: "left",
      addData: {},
      controlData: {},
      roundDatas: [],
      productDatas: [],
      multipleSelection: [],
      fileList: [],
      fileList1: [],
      fileyHeader: {},
      fileData: {
        type: 1
      },
      addData: {
        name: "",
        price: "",
        score: "",
        mainPicture: "",
        detailPicture: []
      }
    };
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this.fileyHeader = {
        token: getUserInfo.token,
        "Content-Type": "application/json;charset=utf-8"
      };
      loadingInstance(Loading);
      this._getList();
      this._getCategory();
      this._getSupplier();
      this._getLogistics();
    }
  },
  methods: {
    getProductType(scope) {
      let type = scope.row.type;
      if (type == "1") return "商城商品";
      if (type == "2") return "门店商品";
      if (type == "3") return "基础商品";
      return "";
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChange(val) {
      console.log(val);
      this.pageNum = val;
      this._getList();
    },
    uploadSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 101);

      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.addData.mainPicture = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    uploadSectionFile1(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 101);

      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.addData.detailPicture.push(res.data);
        } else {
          Error(this, res);
        }
      });
    },
    handleGroupValue(row, column, cellValue, index) {
      //是否团购商品  1是
      if(cellValue == 1){
        return "是";
      }else{
        return "否";
      }
    },
    handleGiftPkgValue(row, column, cellValue, index) {
      //是否为消费礼包  1是 0否
      if(cellValue == 1){
        return "是";
      }else{
        return "否";
      }
    },
    handleStatusValue(row, column, cellValue, index) {
      //商品状态  1正常    0.下架
      switch (cellValue) {
        case 0:
          return "下架";
        case 1:
          return "在售";
      }
    },
    handleAdd() {
      this.$router.push({
        path: "/addProduct"
      });
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.productDatas[index];
    },
    handleStatus(data, status) {
      let param = {
        id: data.id,
        state: status
      };
      loadingInstance(Loading);
      modifyStatus(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          Success(this, res);
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    handleEdit(index, row) {
      // window.localStorage.setItem('productId',row.id);
      this.$router.push({
        path: "/addProduct?productId=" + row.id
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleRemove1(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    _deleteProduct() {
      let param = {
        id: this.controlData.id
      };
      loadingInstance(Loading);
      deleteProduct(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.deleteDialogVisible = false;
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    _getCategory() {
      let param = {};
      // loadingInstance(Loading)
      getCategorys(param).then(res => {
        // loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          if (res.data.length > 0) {
            //处理分类结构
            this.categoryOptions = [];
            for (var i = 0; i < res.data.length; i++) {
              let cate = res.data[i];
              let category = {};
              category.value = cate.id;
              category.label = cate.name;
              if (cate.categoryVos != null) {
                let child = [];
                for (var j = 0; j < cate.categoryVos.length; j++) {
                  let cc = {};
                  cc.value = cate.categoryVos[j].id;
                  cc.label = cate.categoryVos[j].name;
                  child.push(cc);
                }
                category.children = child;
              }
              this.categoryOptions.push(category);
            }
          }
        } else {
          Error(this, res);
        }
      });
    },
    _getSupplier() {
      let param = {};
      // loadingInstance(Loading)
      getAllSupplier(param).then(res => {
        // loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.supplierOptions = res.data.records;
        } else {
          Error(this, res);
        }
      });
    },
    _getLogistics() {
      let param = {
        current: this.pageNum,
        size: 100
      };
      // loadingInstance(Loading)
      getAllSupplier(param).then(res => {
        // loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.logisticsOptions = res.data.records;
        } else {
          Error(this, res);
        }
      });
    },
    _getList() {
      let param = {
        /*
        brandId:			//品牌id*/
        homePage: this.homePage, //是否在首页展示
        supplierId: this.supplierId, //供应商id
        categoryId: this.categoryId, //分类id
        content: this.keywords,
        current: this.pageNum,
        size: this.pageSize
      };
      // loadingInstance(Loading)
      getAllProduct(param).then(res => {
        if (res.status === ERR_OK) {
          this.productDatas = res.data.records;
          this.totalNum = res.data.total;
          if (res.data.pages > 1) {
            this.paginationShow = true;
          }
        } else {
          Error(this, res);
        }
        loadingInstance(Loading).close();
      });
    }
  }
};
</script>
<style scoped>
.user {
  z-index: 9;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
}
.userOperate {
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.userTable {
  padding: 10px;
  position: relative;
}
</style>
<style>
.userOperate .el-input {
  width: 180px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.userOperate .el-button {
  width: 100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/product.vue